module.exports = __webpack_public_path__ + "static/media/close-primary.53e79b1a.svg";